import axios from 'axios'
import appConfig from '@/appconfig'
import endpoint from '@constants/apipath'
import getSavedState from '../../utils/get-state'
import saveState from '../../utils/save-state'

export const state = {
  currentUser: getSavedState('auth.currentUser'),
  menuAPITries: 0,
  tokenExpiry: 0,
}

export const mutations = {
  SET_CURRENT_USER(state, newValue) {
    state.currentUser = newValue
    saveState('auth.currentUser', newValue)
    setDefaultAuthHeaders(state)
  },
  SET_CURRENT_USERINFO(state, newValue) {
    state.currentUser.userInfo = newValue
    saveState('auth.currentUser', newValue)
    setDefaultAuthHeaders(state)
  },
  SET_MENUAPI_CALLS(state, newValue) {
    state.menuAPITries = newValue
  },
  SET_TOKEN_EXPIRY_TIME(state, newValue) {
    state.tokenExpiry = newValue
  },
}

export const getters = {
  // Whether the user is currently logged in.
  loggedIn(state) {
    return !!state.currentUser
  },

  userInfo(state) {
    return state.currentUser.userInfo
  },

  userId(state) {
    return state.currentUser.userInfo.userId
  },

  customerID(state) {
    return state.currentUser.userInfo.customerId
  },
  menuAPITries(state) {
    return state.menuAPITries
  },
}

export const actions = {
  // This is automatically run in `src/state/store.js` when the app
  // starts, along with any other actions named `init` in other modules.
  init({ state, dispatch }) {
    setDefaultAuthHeaders(state)
    dispatch('validate')
  },

  updateUserInfo({ commit }, { userInfor } = {}) {
    commit('auth/SET_CURRENT_USERINFO', userInfor, {
      root: true,
    })
  },

  // Logs in the current user.
  logIn({ commit, dispatch, getters }, { username, password } = {}) {
    if (getters.loggedIn) return dispatch('validate')

    var loginData = JSON.stringify({
      Email: username,
      Password: password,
    })
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.identityApiPath.login}`,
        JSON.parse(loginData)
      )
      .then((response) => {
        const user = response.data ? response.data.value : null
        if (response.data && response.data.statusCode === 200) {
          commit('SET_CURRENT_USER', user)
          commit('SET_TOKEN_EXPIRY_TIME', user.expires_in)
        }
        return response.data
      })
  },

  // Logs out the current user.
  logOut({ commit }) {
    const headers = {
      'Content-Type': 'application/json',
      Authorization: axios.defaults.headers.common.Authorization,
    }

    return axios
      .post(`${appConfig.apiEndPoint}${endpoint.identityApiPath.logout}`, {
        headers: headers,
      })
      .then((response) => {
        commit('SET_CURRENT_USER', null)
        commit('lenders/SET_LENDER_ID', null, {
          root: true,
        })
      })
  },

  contactAdmin({ commit }, { username } = {}) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${
          endpoint.identityApiPath.accountunlock
        }/${username}`
      )
      .then((response) => {
        return response
      })
  },

  // Validates the current user's token and refreshes it
  // with new data from the API.
  validate({ commit, state }) {
    if (!state.currentUser) return Promise.resolve(null)

    return state.currentUser
  },

  getNewToken({ commit }) {
    return axios
      .post(`${appConfig.apiEndPoint}${endpoint.identityApiPath.getNewToken}`)
      .then((response) => {
        const user = response.data ? response.data.value : null
        if (response.data && response.data.statusCode === 200) {
          commit('SET_CURRENT_USER', user)
          commit('SET_TOKEN_EXPIRY_TIME', user.expires_in)
        }
        return response.data
      })
  },
}

// ===
// Private helpers
// ===

function setDefaultAuthHeaders(state) {
  axios.defaults.headers.get['Pragma'] = 'no-cache'
  axios.defaults.headers.get['Cache-Control'] = 'no-cache, no-store'
  axios.defaults.headers.common.Authorization =
    state.currentUser && state.currentUser.access_token
      ? `Bearer ${state.currentUser.access_token}`
      : ''
}
